export enum ComparisonType {
  Entity = 'entity',
  CompetitionAverage = 'competitionAverage',
}
